import React from 'react';
import { getText } from 'src/utils/i18n';
import './index.scss';

const SeoRfq = ({ i18n, productId }) => {
  return (
    <div
      className="scc-wrapper detail-module module-seoRfq"
      data-spm="sefqeorf6"
    >
      <div className="ls-icon rfq">
        <span className="ico-leaf" />
        {getText(
          i18n,
          'seoRfq_tip_text',
          'Not exactly what you want? 1 request, multiple quotations',
        )}{' '}
        <a
          data-role="rfq"
          rel="nofollow"
          href={`//rfq.alibaba.com/rfq/post.htm?productId=${productId}&tracelog=search_detail_bottom_201406`}
          className="emphasis"
          data-domdot="id:5220,ext:cparea=Key_Action_ZTC"
          target="_blank"
        >
          {getText(i18n, 'seoRfq_tip_text_tail', 'Get Quotations Now')} {'>>'}
        </a>
      </div>
    </div>
  );
};

export default SeoRfq;
